import React from 'react'
import Skeleton from 'react-loading-skeleton'

import DiscountCell from './DiscountCell'

import { DATA_DISCOUNT } from '../../const/sort'
import { tableColumnsSize } from '../../const/tableColumnsSize'

const DiscountCol = ({ classes, formik, editProductId }) => {
  return {
    header: 'Disc. %',
    headClassName: classes.quotationBuilderCol,
    className: classes.quotationBuilderCol,
    attributes: { 'data-copy': DATA_DISCOUNT },
    style: { minWidth: tableColumnsSize.discount, maxWidth: tableColumnsSize.discount },
    Cell: (productValues, productIndex) => {
      const isProductLoading = productValues.isLoading
      // used on add bulk products
      const isInventoryLoading = productValues.isInventoryLoading
      const isProductSelected = !!productValues.data

      if (isProductLoading || isInventoryLoading) {
        return <Skeleton width="100%" />
      } else if (isProductSelected) {
        return (
          <DiscountCell
            formik={formik}
            productValues={productValues}
            productIndex={productIndex}
            isEditMode={editProductId === productValues.id}
          />
        )
      } else {
        return null
      }
    }
  }
}

export default DiscountCol
